import { DataFormats } from '@skylab-shared/constants';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { PurchaseDocumentKind, SaleDocumentKind } from '@skylab-shared/dataModel';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { format } from 'fecha';


export interface BalanceSheetParameters {
    convertToPln: boolean;
    dateFrom: Date;
    dateTo: Date;
    omitInvoiceIssuedToReceipt: boolean;
    search: string;
    kinds:  (SaleDocumentKind | PurchaseDocumentKind)[];
}

export interface BalanceSheetModel {
    baseCurrencyGross: number;
    baseCurrencyId: string;
    baseCurrencyNet: number;
    baseCurrencyVat: number;
    currencyId: string;
    documentKind: SaleDocumentKind | PurchaseDocumentKind;
    gross: number;
    net: number;
    vat: number;
}

interface BalanceSheetInternalItem {
    baseCurrencyGross: number;
    baseCurrencyId: string;
    baseCurrencyNet: number;
    baseCurrencyVat: number;
    documentCurrencyId: string;
    documentKind: SaleDocumentKind | PurchaseDocumentKind;
    gross: number;
    net: number;
    vat: number;
}

export class BalanceSheetCollectionQuery extends Query<BalanceSheetModel[]> {
    public constructor (public readonly parameters: BalanceSheetParameters) {
        super();
    }
}

export class BalanceSheetCollectionQueryHandlerBase implements QueryHandler<BalanceSheetCollectionQuery, BalanceSheetModel[]> {
    private static Url = TaggedUrl.join('balance', [Tags.Api]);

    public constructor(
        private readonly http: HttpService) {}

    public async handleAsync(query: BalanceSheetCollectionQuery): Promise<BalanceSheetModel[]> {
        const { data } = await this.http.get<BalanceSheetInternalItem[]>(BalanceSheetCollectionQueryHandlerBase.Url, {
            params: {
                ...query.parameters,
                dateFrom: query.parameters.dateFrom && format(query.parameters.dateFrom, DataFormats.date.webApi),
                dateTo: query.parameters.dateTo && format(query.parameters.dateTo, DataFormats.date.webApi)
            },
            timeout: 3 * MS_PER_MINUTE
        });

        return data.map(item => ({
            baseCurrencyGross: item.baseCurrencyGross,
            baseCurrencyId: item.baseCurrencyId,
            baseCurrencyNet: item.baseCurrencyNet,
            baseCurrencyVat: item.baseCurrencyVat,
            currencyId: item.documentCurrencyId,
            documentKind: item.documentKind,
            gross: item.gross,
            net: item.net,
            vat: item.vat,
        }));
    }
}
